'use strict';
var util = require('../util');

module.exports = {
  appVersion: '7.9.2',
  
  previewImage: util.actionMapping('previewImage')
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@dp/dpapp/lib/patch/patch-7.9.2.js
// module id = 552
// module chunks = 0